//#region src/client/errors.ts
var SafeClientError = class extends Error {};
var SimulationError = class extends SafeClientError {
	constructor(message, options) {
		super(message, { cause: options?.cause });
		this.executionError = options?.executionError;
	}
};
/** An error returned for an individual object lookup. */
var ObjectError = class extends SafeClientError {
	constructor(code, message, options) {
		super(message, { cause: options?.cause });
		this.code = code;
		this.reason = options?.reason ?? "unknown";
		this.objectId = options?.objectId;
	}
};
const TRANSACTION_ERROR_MESSAGES = { notFound: (digest) => `Transaction ${digest} not found` };
/** An error returned by a transaction lookup. */
var TransactionError = class extends SafeClientError {
	constructor(reason, digest, options) {
		super(TRANSACTION_ERROR_MESSAGES[reason](digest), options);
		this.reason = reason;
		this.digest = digest;
	}
};
//#endregion
export { ObjectError, SafeClientError, SimulationError, TransactionError };

//# sourceMappingURL=errors.mjs.map